<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

import { required, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import appConfig from "@/app.config";
import officeSvc from "@/services/office";
import { toast } from "vue3-toastify";

/**
 * Office Setting component
 */
export default {
  page: {
    title: "Office",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Office",
      items: [
        {
          text: "Setting",
          href: "#",
        },
        {
          text: "Office",
          active: true,
        },
      ],
      columns: [
        {
          field: "uuid",
          hidden: true,
        },
        {
          label: "Name (TH)",
          field: "name",
        },
        {
          label: "Name (EN)",
          field: "nameEn",
        },
        {
          label: "Phone",
          field: "phone",
        },
        {
          label: "Created Date",
          field: "createdAt",
        },
        {
          label: "Updated Date",
          field: "updatedAt",
        },
        {
          label: "Action",
          field: "button",
          html: true,
          sortable: false,
          tdClass: "text-center",
          thClass: "text-center",
        },
      ],
      rows: [],
      showModalCreate: false,
      showModalEdit: false,
      submitted: false,
      office: {
        uuid: "",
        name: "",
        nameEn: "",
        phone: "",
        // for edit modal title display
        titleName: "",
      },
    };
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations: {
    office: {
      name: {
        required: helpers.withMessage("Name (TH) is required", required),
      },
      phone: {
        required: helpers.withMessage("Phone is required", required),
      },
    },
  },
  mounted() {
    this.get();
  },
  methods: {
    get() {
      officeSvc.getAll().then((resp) => {
        if (resp.data.data === null) {
          return;
        }
        this.rows = resp.data.data;
      });
    },
    create() {
      this.office.uuid = "";
      this.office.name = "";
      this.office.nameEn = "";
      this.office.phone = "";
      this.submitted = false;
      this.showModalCreate = true;
    },
    handleSubmit() {
      this.submitted = true;
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      const payload = {
        name: this.office.name,
        nameEn: this.office.nameEn,
        phone: this.office.phone,
      };

      officeSvc
        .create(payload)
        .then((resp) => {
          if (resp.status === 200) {
            toast.success("Created Successfully", {
              autoClose: localStorage.getItem("toastCountdown"),
            });
          } else {
            toast.error("Created Failed", {
              autoClose: localStorage.getItem("toastCountdown"),
            });
          }
        })
        .catch((err) => {
          toast.error(err, {
            autoClose: localStorage.getItem("toastCountdown"),
          });
        })
        .finally(() => {
          this.get();
          this.showModalCreate = false;
          this.submitted = false;
        });
    },
    edit(data) {
      this.office.uuid = data.uuid;
      this.office.name = data.name;
      this.office.nameEn = data.nameEn;
      this.office.phone = data.phone;
      this.office.titleName = data.name;
      this.submitted = false;
      this.showModalEdit = true;
    },
    handleEditSubmit() {
      this.submitted = true;
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      const payload = {
        name: this.office.name,
        nameEn: this.office.nameEn,
        phone: this.office.phone,
      };

      officeSvc
        .update(this.office.uuid, payload)
        .then((resp) => {
          if (resp.status === 200) {
            toast.success("Edited Successfully", {
              autoClose: localStorage.getItem("toastCountdown"),
            });
          } else {
            toast.error("Edited Failed", {
              autoClose: localStorage.getItem("toastCountdown"),
            });
          }
        })
        .catch((err) => {
          toast.error(err, {
            autoClose: localStorage.getItem("toastCountdown"),
          });
        })
        .finally(() => {
          this.get();
          this.showModalEdit = false;
          this.submitted = false;
        });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-12">
                <!-- MODAL CREATE -->
                <div class="text-sm-end">
                  <button
                    type="button"
                    class="btn btn-success btn-rounded mb-2 me-2"
                    @click="create"
                  >
                    <i class="mdi mdi-plus me-1"></i> Add Office
                  </button>
                  <b-modal
                    v-model="showModalCreate"
                    title="Add Office"
                    title-class="text-black font-18"
                    body-class="p-3"
                    hide-footer
                    no-close-on-backdrop
                  >
                    <form @submit.prevent="handleSubmit">
                      <div class="row">
                        <div class="col-12">
                          <div class="mb-3">
                            <label for="officeName"
                              >Name (TH)
                              <span class="is-required">*</span></label
                            >
                            <input
                              id="officeName"
                              v-model="office.name"
                              type="text"
                              class="form-control"
                              :class="{
                                'is-invalid': submitted && v$.office.name.$error,
                              }"
                            />
                            <div
                              v-if="submitted && v$.office.name.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="v$.office.name.required.$message">{{
                                v$.office.name.required.$message
                              }}</span>
                            </div>
                          </div>
                          <div class="mb-3">
                            <label for="officeNameEn">Name (EN)</label>
                            <input
                              id="officeNameEn"
                              v-model="office.nameEn"
                              type="text"
                              class="form-control"
                            />
                          </div>
                          <div class="mb-3">
                            <label for="officePhone"
                              >Phone
                              <span class="is-required">*</span></label
                            >
                            <input
                              id="officePhone"
                              v-model="office.phone"
                              type="text"
                              class="form-control"
                              :class="{
                                'is-invalid':
                                  submitted && v$.office.phone.$error,
                              }"
                            />
                            <div
                              v-if="submitted && v$.office.phone.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="v$.office.phone.required.$message">{{
                                v$.office.phone.required.$message
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="text-end pt-5 mt-3">
                        <b-button
                          variant="light"
                          @click="showModalCreate = false"
                          >Close</b-button
                        >
                        <b-button type="submit" variant="success" class="ms-1"
                          >Create Office</b-button
                        >
                      </div>
                    </form>
                  </b-modal>
                </div>
                <!-- MODAL CREATE -->

                <!-- MODAL EDIT -->
                <div class="text-sm-end">
                  <b-modal
                    v-model="showModalEdit"
                    :title="`Edit Office : ${office.titleName}`"
                    title-class="text-black font-18"
                    body-class="p-3"
                    hide-footer
                    no-close-on-backdrop
                  >
                    <form @submit.prevent="handleEditSubmit">
                      <div class="row">
                        <div class="col-12">
                          <div class="mb-3">
                            <label for="editOfficeName"
                              >Name (TH)
                              <span class="is-required">*</span></label
                            >
                            <input
                              id="editOfficeName"
                              v-model="office.name"
                              type="text"
                              class="form-control"
                              :class="{
                                'is-invalid': submitted && v$.office.name.$error,
                              }"
                            />
                            <div
                              v-if="submitted && v$.office.name.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="v$.office.name.required.$message">{{
                                v$.office.name.required.$message
                              }}</span>
                            </div>
                          </div>
                          <div class="mb-3">
                            <label for="editOfficeNameEn">Name (EN)</label>
                            <input
                              id="editOfficeNameEn"
                              v-model="office.nameEn"
                              type="text"
                              class="form-control"
                            />
                          </div>
                          <div class="mb-3">
                            <label for="editOfficePhone"
                              >Phone
                              <span class="is-required">*</span></label
                            >
                            <input
                              id="editOfficePhone"
                              v-model="office.phone"
                              type="text"
                              class="form-control"
                              :class="{
                                'is-invalid':
                                  submitted && v$.office.phone.$error,
                              }"
                            />
                            <div
                              v-if="submitted && v$.office.phone.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="v$.office.phone.required.$message">{{
                                v$.office.phone.required.$message
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="text-end pt-5 mt-3">
                        <b-button variant="light" @click="showModalEdit = false"
                          >Close</b-button
                        >
                        <b-button type="submit" variant="warning" class="ms-1"
                          >Update Office</b-button
                        >
                      </div>
                    </form>
                  </b-modal>
                </div>
                <!-- MODAL EDIT -->
              </div>
            </div>
            <div class="table-responsive">
              <vue-good-table
                :search-options="{
                  enabled: true,
                }"
                :pagination-options="{
                  enabled: true,
                  perPage: 10,
                  mode: 'records',
                }"
                :line-numbers="true"
                styleClass="tableOne vgt-table striped"
                :columns="columns"
                :rows="rows"
              >
                <template #table-row="props">
                  <span v-if="props.column.field == 'button'">
                    <b-button
                      size="sm"
                      variant="success"
                      @click="edit(props.formattedRow)"
                    >
                      <i
                        class="mdi mdi-pencil font-size-16 align-middle me-2"
                      ></i>
                      Edit
                    </b-button>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
              </vue-good-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<style>
span.is-required {
  color: red;
}
</style>
